export default __webpack_public_path__ + "static/media/welcome.56640fc4.mp3";